module.exports = __webpack_public_path__ + "img/ico-instagram.76d74cef.svg";